import {Button, Grid, Switch, TextField, Theme, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {getHandleFieldChange} from '../../../utils/formHelpers';
import {TourRoleTypes} from '../../../graphql/groups.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  content: {
    padding: theme.spacing(0, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  radioGroup: {},
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

export interface FilterValues {
  first_name: string
  last_name: string
  group_role?: number
  email: string
  cellphone: string
  tour_role: number
  validated_true: boolean
  validated_false: boolean
  cancelled_true: boolean
  cancelled_false: boolean
  disabled_true: boolean
  disabled_false: boolean
  authorized_true: boolean
  authorized_false: boolean
}

export const GroupMemberSearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues }) => {
  const {filters, initialFilters} = props;
  const classes = useStyles();
  const [formState, setFormState] = useState({...filters});

  useEffect(() => {
    setFormState(props.filters)
  }, [props.filters]);

  const handleClear = () => {
    props.applyFilters(initialFilters);
  };

  const handleFieldChange = getHandleFieldChange(setFormState);

  const applyFilters = () => {
    props.applyFilters(formState);
  };

  return (
    <React.Fragment>
      <div className={classes.content}>
        <div className={classes.contentSection}>

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                  fullWidth
                  label="First Name"
                  name="first_name"
                  onChange={handleFieldChange}
                  value={formState.first_name}
                  variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                  fullWidth
                  label="Last Name"
                  name="last_name"
                  onChange={handleFieldChange}
                  value={formState.last_name}
                  variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                onChange={handleFieldChange}
                value={formState.email}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Cellphone"
                name="cellphone"
                onChange={handleFieldChange}
                value={formState.cellphone}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                  fullWidth
                  label="Tour Role"
                  name="tour_role"
                  onChange={handleFieldChange}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={formState.tour_role}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
              >
                <option value={-1}>All Roles</option>
                {TourRoleTypes.map((type, i) => (
                    <option key={i} value={i}>
                      {TourRoleTypes[i].name}
                    </option>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item xs={4}><Typography variant="h5">Approved?</Typography></Grid>
                <Grid item><Typography variant="h5">Yes</Typography></Grid>
                <Grid item>
                  <Switch
                      checked={formState.authorized_true}
                      color="secondary"
                      edge="start"
                      name="authorized_true"
                      onChange={handleFieldChange}
                      value={formState.authorized_true}
                  />
                </Grid>
                <Grid item><Typography variant="h5">No</Typography></Grid>
                <Grid item>
                  <Switch
                      checked={formState.authorized_false}
                      color="secondary"
                      edge="start"
                      name="authorized_false"
                      onChange={handleFieldChange}
                      value={formState.authorized_false}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item xs={4}><Typography variant="h5">Validated?</Typography></Grid>
                <Grid item><Typography variant="h5">Yes</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.validated_true}
                    color="secondary"
                    edge="start"
                    name="validated_true"
                    onChange={handleFieldChange}
                    value={formState.validated_true}
                  />
                </Grid>
                <Grid item><Typography variant="h5">No</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.validated_false}
                    color="secondary"
                    edge="start"
                    name="validated_false"
                    onChange={handleFieldChange}
                    value={formState.validated_false}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item xs={4}><Typography variant="h5">Disabled?</Typography></Grid>
                <Grid item><Typography variant="h5">Yes</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.disabled_true}
                    color="secondary"
                    edge="start"
                    name="disabled_true"
                    onChange={handleFieldChange}
                    value={formState.disabled_true}
                  />
                </Grid>
                <Grid item><Typography variant="h5">No</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.disabled_false}
                    color="secondary"
                    edge="start"
                    name="disabled_false"
                    onChange={handleFieldChange}
                    value={formState.disabled_false}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item xs={4}><Typography variant="h5">Cancelled?</Typography></Grid>
                <Grid item><Typography variant="h5">Yes</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.cancelled_true}
                    color="secondary"
                    edge="start"
                    name="cancelled_true"
                    onChange={handleFieldChange}
                    value={formState.cancelled_true}
                  />
                </Grid>
                <Grid item><Typography variant="h5">No</Typography></Grid>
                <Grid item>
                  <Switch
                    checked={formState.cancelled_false}
                    color="secondary"
                    edge="start"
                    name="cancelled_false"
                    onChange={handleFieldChange}
                    value={formState.cancelled_false}
                  />
                </Grid>
              </Grid>
            </Grid>

          </Grid>

        </div>
      </div>
      <div className={classes.actions}>
        <Button id="clear" fullWidth onClick={handleClear} variant="contained">
          <DeleteIcon className={classes.buttonIcon}/>
          Clear
        </Button>
        <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
          Apply filters
        </Button>
      </div>

    </React.Fragment>
  );
};

export default GroupMemberSearchFilter;